import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import VehicleSelection from './components/VehicleSelection';
import CompartmentQuiz from './components/CompartmentQuiz';
import MultipleChoiceQuiz from './components/MultipleChoiceQuiz';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminLogin from './components/AdminLogin';
import { AuthProvider, useAuth } from './AuthContext';
// Auth & Highscore wurden entfernt, daher keine speziellen Routen/Provider mehr

// Feuerwehr-Theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#d32f2f', // Feuerwehr-Rot
      light: '#ff6659',
      dark: '#9a0007',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#1976d2', // Feuerwehr-Blau
      light: '#63a4ff',
      dark: '#004ba0',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
      paper: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/admin-login" replace />;
  return children;
};

const DynamicCompartmentQuiz = () => {
  const { vehicleId } = useParams();
  return <CompartmentQuiz vehicleId={Number(vehicleId)} />;
};

const DynamicMultipleChoiceQuiz = () => {
  const { vehicleId } = useParams();
  return <MultipleChoiceQuiz vehicleId={Number(vehicleId)} />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<VehicleSelection />} />
            <Route path="/hlf/fach-quiz" element={<CompartmentQuiz vehicleId={1} />} />
            <Route path="/lf/fach-quiz" element={<CompartmentQuiz vehicleId={2} />} />
            <Route path="/hlf/mc-quiz" element={<MultipleChoiceQuiz vehicleId={1} />} />
            <Route path="/lf/mc-quiz" element={<MultipleChoiceQuiz vehicleId={2} />} />
            <Route path="/vehicle/:vehicleId/fach-quiz" element={<DynamicCompartmentQuiz />} />
            <Route path="/vehicle/:vehicleId/mc-quiz" element={<DynamicMultipleChoiceQuiz />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
